import React from 'react';
import DimensionAssessment from './DimensionAssessment';
import AssessmentNavigation from './AssessmentNavigation';
import AssessmentProgress from './AssessmentProgress';
import { readinessQuestions } from '@/data/readiness';

interface AssessmentContainerProps {
  currentDimension: number;
  dimensionAnswers: Record<number, string>;
  hasChanges: boolean;
  onAnswerChange: (localIndex: number, value: string) => void;
  onNext: () => void;
  onPrevious: () => void;
  onSave: () => Promise<void>;
  isCurrentDimensionComplete: boolean;
}

const AssessmentContainer = ({
  currentDimension,
  dimensionAnswers,
  hasChanges,
  onAnswerChange,
  onNext,
  onPrevious,
  onSave,
  isCurrentDimensionComplete
}: AssessmentContainerProps) => {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <AssessmentProgress 
          currentDimension={currentDimension}
          totalDimensions={readinessQuestions.length}
        />
        
        <div className="mt-8">
          <DimensionAssessment
            key={`dimension-${currentDimension}`}
            dimension={readinessQuestions[currentDimension]}
            answers={dimensionAnswers}
            onAnswerChange={onAnswerChange}
          />
        </div>

        <AssessmentNavigation
          currentDimension={currentDimension}
          totalDimensions={readinessQuestions.length}
          onNext={onNext}
          onPrevious={onPrevious}
          onSave={onSave}
          isNextDisabled={!isCurrentDimensionComplete}
          hasChanges={hasChanges}
        />
      </div>
    </div>
  );
};

export default AssessmentContainer;